import { createSlice, current, PayloadAction } from '@reduxjs/toolkit';

import {
  ISolution,
  ISolutions,
  ISolutionsResult,
  ISolutionsState
} from './types';
import initialSolutionsState from './initialState';
import Helpers from 'utils/Helpers';
import newSolObj from 'constants/newSolution';

const solutionsSlice = createSlice({
  name: 'solutions',
  initialState: initialSolutionsState(),
  reducers: {
    set_solutions(
      state: ISolutionsState,
      action: PayloadAction<ISolutionsResult[]>
    ) {
      state.solutions = action.payload;
      state.loading = false;
    },
    set_solutions_to_save(
      state: ISolutionsState,
      action: PayloadAction<ISolutionsResult[]>
    ) {
      state.solutionsToShow = action.payload;
      state.loading = false;
    },
    edit_solution(
      state: ISolutionsState,
      action: PayloadAction<{
        solId: string | number;
        solData: ISolution;
        key: string;
        value: string;
      }>
    ) {
      const oldState = current(state);
      const { solId, solData, key, value } = action.payload;

      state.solutionsToSave = {
        ...oldState.solutionsToSave,
        [solId]: {
          ...solData,
          ...oldState.solutionsToSave[solId],
          [key]: value
        }
      };

      state.loading = false;
    },
    reset_solutions_to_save(state: ISolutionsState) {
      state.solutionsToSave = {};
    },
    add_new_solution(state: ISolutionsState, action: PayloadAction<number>) {
      const oldState = current(state);
      const regReqObj = oldState.solutions.filter(
        (item: ISolutions) => item.id === action.payload
      )[0];

      const tempId = `temp_${Date.now()}`;
      const newSolution = newSolObj(regReqObj.id);

      state.solutionsToShow = Helpers.isObjEmpty(
        oldState.solutionsToShow[action.payload]
      )
        ? {
            ...oldState.solutionsToShow,
            [action.payload]: {
              [tempId]: {
                ...regReqObj,
                SOLUTIONS: newSolution
              }
            }
          }
        : {
            ...oldState.solutionsToShow,
            [action.payload]: {
              ...oldState.solutionsToShow[action.payload],
              [tempId]: {
                ...regReqObj,
                SOLUTIONS: newSolution
              }
            }
          };

      state.solutionsToSave = {
        ...oldState.solutionsToSave,
        [tempId]: newSolution
      };

      state.loading = false;
    },
    set_loading(state: ISolutionsState) {
      state.loading = true;
    },
    set_error(state: ISolutionsState, action: PayloadAction<any>) {
      state.error = action.payload;
      state.loading = false;
    }
  }
});

export default solutionsSlice;
